import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=b25e2256&scoped=true&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHeader.vue?vue&type=style&index=0&id=b25e2256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25e2256",
  null
  
)

export default component.exports